<template>
  <div v-if="isShowResultBanner" class="result_banner2">
    <bxs-swiper
      ref="bxsSwiper"
      :autoplay="false"
      :style="{
        width: window.innerWidth + 'px',
        maxWidth: '480px',
      }"
      @slide="slide"
    >
      <bxs-swiper-item
        v-for="prod in allMediaData.list"
        :key="prod.productId"
        :style="{
          width: window.innerWidth + 'px',
          maxWidth: '480px',
        }"
      >
        <div
          v-if="prod.videoList && prod.videoList[0]"
          class="result_banner2_img"
          :style="{
            minHeight: playConfig.playingVideoId
              ? (1080 / 1920) * window.innerWidth + 'px'
              : 'auto',
          }"
          @click="playCurrentVideo(prod)"
        >
          <img
            v-show="!playConfig.playingVideoId"
            :src="prod.videoList[0].bgImg"
            :data-stat-id="Jax && Jax.isApp() ? 'sp_a' : 'sp_c'"
            :data-stat-ep="
              JSON.stringify({
                v: '2.0',
                key: getCurrentVideo(prod).id,
                spbb: getCurrentVideo(prod).key,
              })
            "
            @load="$emit('done')"
          >
          <template v-for="video in prod.videoList">
            <div
              :key="video.id"
              :class="`fixed_wraper_video fixed_wraper_${video.id}`"
            >
              <MyVideo
                v-show="playConfig.playingVideoId === video.id"
                :ref="video.id"
                :theme="theme"
                :data-video-id="video.id"
                :class="`fixed_${video.id}`"
                :play-config="playConfig"
                :product-video="productVideo"
                :media-data="video"
                @wxClientSaveOperate="wxClientSaveOperate"
              />
            </div>
          </template>

          <template v-if="!playConfig.playingVideoId">
            <div
              v-if="prod.videoList[0].videoUrl"
              class="result_banner2_btn"
              :data-stat-id="Jax && Jax.isApp() ? 'sp_a' : 'sp_c'"
              :data-stat-ep="
                JSON.stringify({
                  v: '2.0',
                  key: getCurrentVideo(prod).id,
                  spbb: getCurrentVideo(prod).key,
                })
              "
            >
              <i
                v-if="card.telephone && card.telephone.substr(-1) % 2"
                class="result_banner2_btn_icon"
              />
              <img
                v-else
                class="result_banner2_btn2 result_banner2_btn2_ani"
                src="//media.winbaoxian.com/autoUpload/planbook/video2_button3x_673c1fd10d4647d.png"
                alt
              >

              <!-- <span v-else class="result_banner2_btn_gif gif_ani_rotate"></span> -->
            </div>
            <bxs-loading v-else class="player_loading" size="30px" />
          </template>
        </div>
      </bxs-swiper-item>
    </bxs-swiper>
    <!-- <span
      v-if="Jax && Jax.isApp() && productVideo.videoList && productVideo.videoList.length > 1"
      class="result_banner2_video_choose"
      data-stat-id="spbb_dj"
      @click.stop="openVideoTypePopup"
    >选择视频类型</span>-->

    <!-- <bxs-bottom-sheets
      v-model="isShowChooseVideo"
      title="选择视频类型"
      height="middle"
      :prevent-scroll-through="true"
      @domReady="domReady"
    >
      <div class="result_choose_video">
        <ul v-if="productVideo">
          <li
            v-for="video in productVideo.videoList"
            :key="video.id"
            :class="{
              active: video.key === allMediaData.videoTypeKeys[productVideo.productId]
            }"
            data-stat-id="spbb"
            :data-stat-ep="JSON.stringify({
              key: video.key,
              name: video.title
            })"
            @click="chooseVideoType(video)"
          >
            <h5>{{video.title}}</h5>
            <p>{{video.description}}</p>
          </li>
        </ul>
        <p>针对不同类型客户，定制专属视频讲解方案</p>
      </div>
    </bxs-bottom-sheets>-->
    <div
      v-show="playConfig.status && playConfig.status !== 'normal'"
      class="fixed_video_playing"
      :style="
        playConfig.status === 'full'
          ? {
            width: '100%',
            height: '100%',
          }
          : {}
      "
      @click.stop="switchToFullPlayerPane('mini')"
    />
  </div>
  <div v-else>
    <div
      v-if="
        Array.isArray(allMediaData.list) &&
          allMediaData.list[0].videoList &&
          allMediaData.list[0].videoList[0]
      "
      class="result_banner2_img"
    >
      <img :src="allMediaData.list[0].videoList[0].bgImg">
    </div>
  </div>
</template>

<script>
import Jax from '@bxs/jax'
import * as API from 'api/index'
import * as CM from 'common/js/common'
import { orientationChanged } from './components/utils'
import { Loading, Swiper, SwiperItem, BottomSheets } from 'bxs-ui-vue'
import MyVideo from './video.vue'

export default {
  name: 'VideoIndex',
  components: {
    [Loading.name]: Loading,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
    [BottomSheets.name]: BottomSheets,
    MyVideo
  },
  filters: {},
  mixins: [],
  props: {
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    allMediaData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShowResultBanner: true,
      uuid: CM.getUrlParam('uuid'),
      playConfig: {
        status: '', // full: 全屏, normal: 常规, mini: 小窗口
        playingVideoId: null
      },
      isShowChooseVideo: false,
      productVideo: this.allMediaData.list[0],
      window,
      theme: CM.getUrlParam('theme'),
      Jax
    }
  },
  computed: {},
  watch: {
    playConfig: {
      deep: true,
      handler (val) {
        let activeSwiperEle = document.querySelector('.bx-swiper-item--active')
        let fixedVideoWrapperEle = document.querySelector(
          '.fixed_video_playing'
        )
        let playingVideoEle = null
        if (activeSwiperEle && fixedVideoWrapperEle) {
          switch (val.status) {
            case 'full':
            case 'mini':
              playingVideoEle = activeSwiperEle.querySelector(
                `.fixed_${val.playingVideoId}`
              )
              if (playingVideoEle) {
                fixedVideoWrapperEle.appendChild(playingVideoEle)
              }
              break
            default:
              playingVideoEle = fixedVideoWrapperEle.firstElementChild
              if (playingVideoEle) {
                activeSwiperEle
                  .querySelector(
                    `.fixed_wraper_${playingVideoEle.getAttribute(
                      'data-video-id'
                    )}`
                  )
                  .appendChild(playingVideoEle)
              }
              break
          }
        }
      }
    }
  },
  created () {},
  mounted () {
    let self = this
    window.addEventListener('scroll', () => {
      this.listenPageScroll()
    })
    document.addEventListener('touchmove', () => {
      this.listenPageScroll()
    })
    document.addEventListener('visibilitychange', e => {
      if (e.target.hidden || document.visibilityState === 'hidden') return
      self.isShowResultBanner = false
      setTimeout(() => {
        self.isShowResultBanner = true
        self.playConfig = {
          status: '', // full: 全屏, normal: 常规, mini: 小窗口
          playingVideoId: null
        }
      }, 500)
    })

    // 监听屏幕旋转
    window.addEventListener(
      'orientationchange',
      () => {
        orientationChanged().then(() => {
          setTimeout(() => {
            self.$forceUpdate()
          }, 300)
        })
      },
      false
    )
  },
  methods: {
    slide (i) {
      if (this.playConfig.playingVideoId) {
        this.$refs[this.playConfig.playingVideoId][0].closeVideoPlayer()
      }
      this.productVideo = this.allMediaData.list[i]

      if (Jax.isIos() && Jax.isWeChat()) {
        let currentVideo = this.getCurrentVideo(this.productVideo)
        if (this.$refs[currentVideo.id][0].isAlreadyPlayed) {
          this.playCurrentVideo(this.productVideo)
        }
      } else {
        this.playCurrentVideo(this.productVideo)
      }
    },
    getCurrentVideo (prod) {
      let video = null
      if (prod.videoList && prod.videoList.length) {
        video =
          prod.videoList.filter(v => {
            return v.key === this.allMediaData.videoTypeKeys[prod.productId]
          })[0] || prod.videoList[0]
      }
      return video
    },
    playCurrentVideo (prod) {
      this.playConfig.playingVideoId = this.getCurrentVideo(prod).id
      if (this.playConfig.status === 'normal') {
        this.switchToFullPlayerPane('normal')
      } else if (!this.playConfig.status) {
        this.closeOrPlayVideo(this.playConfig.playingVideoId, 'play')
        this.playConfig.status = 'normal'
      }
    },
    closeOrPlayVideo (id, type = 'close') {
      // true: 关闭，false: 播放
      let playingVideoInst = this.$refs[id] && this.$refs[id][0]
      if (playingVideoInst) {
        if (type === 'close') {
          playingVideoInst.closeVideoPlayer()
        } else if (type === 'play') {
          if (Jax.isIos() && Jax.isWeChat) {
            playingVideoInst.startPlay()
          } else {
            this.$nextTick(() => {
              playingVideoInst.startPlay()
            })
          }
        }
      }
    },
    listenPageScroll () {
      if (
        this.playConfig.playingVideoId &&
        ['normal', 'mini'].indexOf(this.playConfig.status) !== -1
      ) {
        let sTop = document.documentElement.scrollTop || document.body.scrollTop
        let bannerElement = document.querySelector('.result_banner2_img')
        let videoHeight = 0
        if (bannerElement) {
          videoHeight = bannerElement.clientHeight
        }
        if (sTop > videoHeight) {
          this.playConfig.status = 'mini'
        } else {
          this.playConfig.status = 'normal'
        }
        let playingVideoInst =
          this.$refs[this.playConfig.playingVideoId] &&
          this.$refs[this.playConfig.playingVideoId][0]
        if (playingVideoInst) {
          this.$nextTick(() => {
            playingVideoInst.switchPlay(true)
          })
        }
      }
    },
    wxClientSaveOperate () {
      this.$emit('wxClientSaveOperate')
    },
    openVideoTypePopup () {
      this.isShowChooseVideo = true
    },
    chooseVideoType (video) {
      API.updatePBProductVideoTypeInfo({
        uuid: this.uuid,
        productId: this.productVideo && this.productVideo.productId,
        videoTypeKey: video.key
      }).then(res => {
        if (res.success) {
          this.allMediaData.videoTypeKeys[this.productVideo.productId] =
            video.key
        }
      })
      this.closeOrPlayVideo(this.playConfig.playingVideoId, 'close')
      this.playConfig.playingVideoId = video.id
      this.playConfig.status = 'normal'
      this.closeOrPlayVideo(this.playConfig.playingVideoId, 'play')
      this.isShowChooseVideo = false
    },
    switchToFullPlayerPane (type) {
      if (this.playConfig.status === type) {
        this.playConfig.status = 'full'
        let playingVideoInst =
          this.$refs[this.playConfig.playingVideoId] &&
          this.$refs[this.playConfig.playingVideoId][0]
        if (playingVideoInst) {
          this.$nextTick(() => {
            playingVideoInst.switchPlay(true)
          })
        }
      }
    }
  }
}
</script>

<style lang="postcss">
@import 'variable';
html {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.result_banner2 {
  font-size: 0;
}
.result_banner2_img {
  position: relative;
  font-size: 0;
  img {
    width: 100%;
  }
  & .result_banner2_btn {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    /*background: rgba(0,0,0,0.5);*/
    & .result_banner2_btn_icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 42px;
      width: 42px;
      background-image: url(https://media.winbaoxian.com/autoUpload/activity/video-paly_7c9d6828cc20de0.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }
    & .result_banner2_btn2 {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 60px;
      height: 60px;
      transform: translate(-50%, -50%);
    }
    & .result_banner2_btn2_ani {
      animation: ani_btn2 1s 0.5s infinite;
    }
    & .result_banner2_btn_gif {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(0deg);
      height: 60px;
      width: 60px;
      background-image: url(https://media.winbaoxian.com/autoUpload/planbook/-02_5f3368dadefb0d8.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }
    & .gif_ani_rotate {
      animation: ani_rotate 2s 1s 3;
    }
  }
  & .player_loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.result_banner2_video_choose {
  position: absolute;
  top: 14px;
  right: 0;
  padding: 2px 9px;
  font-size: 14px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  border-top-left-radius: 48px;
  border-bottom-left-radius: 48px;
}
.result_choose_video {
  > p {
    margin-bottom: 9px;
    color: #999;
    font-size: 12px;
    text-align: center;
  }
  > ul {
    li {
      margin-bottom: 15px;
      padding: 9px;
      text-align: center;
      border: 1px solid rgba(112, 172, 246, 1);
      border-radius: 6px;
      color: #508cee;
      background: rgba(80, 140, 238, 0.04);
      h5 {
        @apply --text-ellipsis;
        margin-bottom: 6px;
        font-size: 17px;
        font-weight: bold;
      }
      p {
        @apply --text-ellipsis;
        font-size: 12px;
      }
      &.active {
        border: 1px solid rgba(80, 140, 238, 1);
        color: #fff;
        background: rgba(80, 140, 238, 1);
      }
    }
  }
}

.fixed_video_playing {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
}
.all_video_list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@keyframes ani_rotate {
  0% {
    background-image: url(https://media.winbaoxian.com/autoUpload/planbook/-01_e731f5dd086dc32.png);
    transform: translate(-50%, -50%) rotate(0deg);
  }
  70% {
    transform: translate(-50%, -50%) rotate(360deg);
    background-image: url(https://media.winbaoxian.com/autoUpload/planbook/-02_5f3368dadefb0d8.png);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
    background-image: url(https://media.winbaoxian.com/autoUpload/planbook/-02_5f3368dadefb0d8.png);
  }
}
@keyframes ani_btn2 {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.08);
  }
  100% {
    transform: translate(-50%, -50%) rotate(1.04);
  }
}
</style>
